import { action } from 'typesafe-actions';

import { IKnmReasonTypeExtended } from 'APIPackage/CatalogsModule/interfaces/IKnmReasonTypeExtended';
import { IKnmRejectReasonType } from 'APIPackage/CatalogsModule/interfaces/IKnmRejectReasonType';
import { IKnmSupervisionType } from 'APIPackage/CatalogsModule/interfaces/IKnmSupervisionType';
import { IFetchKnmSupervisionTypesByKnmTypeAndSubjectType } from 'APIPackage/CatalogsModule/services/knmSupervisionTypesApi';
import { IOrderRelation } from 'APIPackage/CatalogsModule/interfaces/IOrderRelation';
import { IKnmType } from 'APIPackage/CatalogsModule/interfaces/IKnmType';
import { IGenericReason } from 'APIPackage/CatalogsModule/interfaces/IGenericReason';

import { CatalogsActionsEnum } from '../enums/CatalogsActionsEnum';
import { CommonCatalogsNamesEnum } from '../enums/CommonCatalogsNamesEnum';
import { IJudgmentCourt } from '../../../APIPackage/CatalogsModule/interfaces/IJudgmentCourt';
import { IKnmTypes248Params } from '../selectors/catalogsSelectors';
import { IUserOrganisation } from '../../../APIPackage/AccountModule/interfaces/IUserOrganisation';
import { ISelectOption } from '../../../UIPackage/MainModule/components/SelectInput';

export const catalogGet = (catalogName: CommonCatalogsNamesEnum, isDeepLoading?: boolean) =>
  action(CatalogsActionsEnum.CATALOG_GET, { catalogName, isDeepLoading });
export const catalogForceGet = (catalogName: CommonCatalogsNamesEnum, isDeepLoading?: boolean) =>
  action(CatalogsActionsEnum.CATALOG_FORCE_GET, { catalogName, isDeepLoading });
export const catalogGetRequest = (catalogName: CommonCatalogsNamesEnum) =>
  action(CatalogsActionsEnum.CATALOG_GET_REQUEST, { catalogName });
export const catalogGetSuccess = (catalogName: CommonCatalogsNamesEnum, data: unknown) =>
  action(CatalogsActionsEnum.CATALOG_GET_SUCCESS, { catalogName, data });
export const catalogGetFailure = (catalogName: CommonCatalogsNamesEnum) =>
  action(CatalogsActionsEnum.CATALOG_GET_FAILURE, { catalogName });
export const catalogKnmReasonTypesGet = (knmTypeId: number, isErp: boolean) =>
  action(CatalogsActionsEnum.CATALOG_KNM_REASON_TYPES_GET, { knmTypeId, isErp });
export const catalogKnmReasonTypesGetRequest = (knmTypeId: number) =>
  action(CatalogsActionsEnum.CATALOG_KNM_REASON_TYPES_GET_REQUEST, { knmTypeId });
export const catalogKnmReasonTypesGetSuccess = (knmTypeId: number, data: IKnmReasonTypeExtended[]) =>
  action(CatalogsActionsEnum.CATALOG_KNM_REASON_TYPES_GET_SUCCESS, {
    knmTypeId,
    data,
  });
export const catalogKnmReasonTypesGetFailure = (knmTypeId: number) =>
  action(CatalogsActionsEnum.CATALOG_KNM_REASON_TYPES_GET_FAILURE, {
    knmTypeId,
  });
export const catalogKnmRejectReasonTypesGet = (knmTypeId: number) =>
  action(CatalogsActionsEnum.CATALOG_KNM_REJECT_REASON_TYPES_GET, { knmTypeId });
export const catalogKnmRejectReasonTypesGetRequest = (knmTypeId: number) =>
  action(CatalogsActionsEnum.CATALOG_KNM_REJECT_REASON_TYPES_GET_REQUEST, { knmTypeId });
export const catalogKnmRejectReasonTypesGetSuccess = (knmTypeId: number, data: IKnmRejectReasonType[]) =>
  action(CatalogsActionsEnum.CATALOG_KNM_REJECT_REASON_TYPES_GET_SUCCESS, {
    knmTypeId,
    data,
  });
export const catalogKnmRejectReasonTypesGetFailure = (knmTypeId: number) =>
  action(CatalogsActionsEnum.CATALOG_KNM_REJECT_REASON_TYPES_GET_FAILURE, {
    knmTypeId,
  });

export const catalogErknmKnmRejectReasonTypesGet = (isPlaned: boolean) =>
  action(CatalogsActionsEnum.CATALOG_ERKNM_KNM_REJECT_REASON_TYPES_GET, { isPlaned });
export const catalogErknmKnmRejectReasonTypesGetRequest = (isPlaned: boolean) =>
  action(CatalogsActionsEnum.CATALOG_ERKNM_KNM_REJECT_REASON_TYPES_GET_REQUEST, { isPlaned });
export const catalogErknmKnmRejectReasonTypesGetSuccess = (isPlaned: boolean, data: IKnmRejectReasonType[]) =>
  action(CatalogsActionsEnum.CATALOG_ERKNM_KNM_REJECT_REASON_TYPES_GET_SUCCESS, {
    isPlaned,
    data,
  });
export const catalogErknmKnmRejectReasonTypesGetFailure = (isPlaned: boolean) =>
  action(CatalogsActionsEnum.CATALOG_ERKNM_KNM_REJECT_REASON_TYPES_GET_FAILURE, {
    isPlaned,
  });

export const catalogErknmKnmConditionsGet = (
  knoOrganizationDictVersionId: string,
  supervisionTypeDictVersionId: string,
  erknmTypeCode: string,
  knmKindId: string | undefined,
) =>
  action(CatalogsActionsEnum.CATALOG_ERKNM_KNM_CONDITIONS_GET, {
    knoOrganizationDictVersionId,
    supervisionTypeDictVersionId,
    erknmTypeCode,
    knmKindId,
  });
export const catalogErknmKnmConditionsGetRequest = (
  knoVersionId: string,
  supervisionVersionId: string,
  erknmTypeCode: string,
  knmKindId: string | undefined,
) =>
  action(CatalogsActionsEnum.CATALOG_ERKNM_KNM_CONDITIONS_GET_REQUEST, {
    knoVersionId,
    supervisionVersionId,
    erknmTypeCode,
    knmKindId,
  });
export const catalogErknmKnmConditionsGetSuccess = (
  knoVersionId: string,
  supervisionVersionId: string,
  erknmTypeCode: string,
  knmKindId: string | undefined,
  data: IKnmReasonTypeExtended[],
) =>
  action(CatalogsActionsEnum.CATALOG_ERKNM_KNM_CONDITIONS_GET_SUCCESS, {
    knoVersionId,
    supervisionVersionId,
    erknmTypeCode,
    knmKindId,
    data,
  });
export const catalogErknmKnmConditionsGetFailure = (
  knoVersionId: string,
  supervisionVersionId: string,
  erknmTypeCode: string,
  knmKindId: string | undefined,
) =>
  action(CatalogsActionsEnum.CATALOG_ERKNM_KNM_CONDITIONS_GET_FAILURE, {
    knoVersionId,
    supervisionVersionId,
    erknmTypeCode,
    knmKindId,
  });

export const catalogPmConditionsGet = (
  knoOrganizationDictVersionId: string,
  supervisionTypeDictVersionId: string,
  profKindId?: string,
  uuidFederalLaw?: string,
) =>
  action(CatalogsActionsEnum.CATALOG_PM_CONDITIONS_GET, {
    knoOrganizationDictVersionId,
    supervisionTypeDictVersionId,
    profKindId,
    uuidFederalLaw,
  });
export const catalogPmConditionsGetRequest = (
  knoVersionId: string,
  supervisionVersionId: string,
  profKindId: string | undefined,
) =>
  action(CatalogsActionsEnum.CATALOG_PM_CONDITIONS_GET_REQUEST, {
    knoVersionId,
    supervisionVersionId,
    profKindId,
  });
export const catalogPmConditionsGetSuccess = (
  knoVersionId: string,
  supervisionVersionId: string,
  profKindId: string | undefined,
  data: IKnmReasonTypeExtended[],
  uuidFederalLaw: string | undefined,
) =>
  action(CatalogsActionsEnum.CATALOG_PM_CONDITIONS_GET_SUCCESS, {
    knoVersionId,
    supervisionVersionId,
    profKindId,
    data,
    uuidFederalLaw,
  });
export const catalogPmConditionsGetFailure = (
  knoVersionId: string,
  supervisionVersionId: string,
  profKindId: string | undefined,
) =>
  action(CatalogsActionsEnum.CATALOG_PM_CONDITIONS_GET_FAILURE, {
    knoVersionId,
    supervisionVersionId,
    profKindId,
  });

export const catalogErpKnmConditionsGet = (
  knoOrganizationId: string,
  supervisionTypeId: string,
  knmTypeCode: string,
  federalLaw: string,
  knmKindId: string | undefined,
) => {
  return action(CatalogsActionsEnum.CATALOG_ERP_KNM_CONDITIONS_GET, {
    knoOrganizationId,
    supervisionTypeId,
    knmTypeCode,
    federalLaw,
    knmKindId,
  });
};
export const catalogErpKnmConditionsGetRequest = (
  knoVersionId: string,
  supervisionTypeId: string,
  knmTypeCode: string,
  federalLaw: string,
  knmKindId: string | undefined,
) =>
  action(CatalogsActionsEnum.CATALOG_ERP_KNM_CONDITIONS_GET_REQUEST, {
    knoVersionId,
    supervisionTypeId,
    knmTypeCode,
    federalLaw,
    knmKindId,
  });
export const catalogErpKnmConditionsGetSuccess = (
  knoVersionId: string,
  supervisionTypeId: string,
  knmTypeCode: string,
  federalLaw: string,
  knmKindId: string | undefined,
  data: IKnmReasonTypeExtended[],
) =>
  action(CatalogsActionsEnum.CATALOG_ERP_KNM_CONDITIONS_GET_SUCCESS, {
    knoVersionId,
    supervisionTypeId,
    knmTypeCode,
    federalLaw,
    knmKindId,
    data,
  });
export const catalogErpKnmConditionsGetFailure = (
  knoVersionId: string,
  supervisionTypeId: string,
  knmTypeCode: string,
  federalLaw: string,
  knmKindId: string | undefined,
) =>
  action(CatalogsActionsEnum.CATALOG_ERP_KNM_CONDITIONS_GET_FAILURE, {
    knoVersionId,
    supervisionTypeId,
    knmTypeCode,
    federalLaw,
    knmKindId,
  });

export const catalogKnmSupervisionTypesByKnmTypeAndSubjectTypeGet = (
  params: IFetchKnmSupervisionTypesByKnmTypeAndSubjectType,
) => action(CatalogsActionsEnum.CATALOG_KNM_SUPERVISION_TYPES_BY_KNM_TYPE_AND_SUBJECT_TYPE_GET, { params });
export const catalogKnmSupervisionTypesByKnmTypeAndSubjectTypeGetRequest = (
  params: IFetchKnmSupervisionTypesByKnmTypeAndSubjectType,
) => action(CatalogsActionsEnum.CATALOG_KNM_SUPERVISION_TYPES_BY_KNM_TYPE_AND_SUBJECT_TYPE_GET_REQUEST, { params });
export const catalogKnmSupervisionTypesByKnmTypeAndSubjectTypeGetSuccess = (
  params: IFetchKnmSupervisionTypesByKnmTypeAndSubjectType,
  data: IKnmSupervisionType[],
) =>
  action(CatalogsActionsEnum.CATALOG_KNM_SUPERVISION_TYPES_BY_KNM_TYPE_AND_SUBJECT_TYPE_GET_SUCCESS, { params, data });
export const catalogKnmSupervisionTypesByKnmTypeAndSubjectTypeGetFailure = (
  params: IFetchKnmSupervisionTypesByKnmTypeAndSubjectType,
) =>
  action(CatalogsActionsEnum.CATALOG_KNM_SUPERVISION_TYPES_BY_KNM_TYPE_AND_SUBJECT_TYPE_GET_FAILURE, {
    params,
  });
export const catalogKnmInspectorsGetById = (id?: string) =>
  action(CatalogsActionsEnum.CATALOG_KNM_INSPECTORS_GET_BY_ID, { id });
export const catalogKnmYearsGet = () => catalogGet(CommonCatalogsNamesEnum.KNM_YEARS);
export const catalogMspCategoriesGet = () => catalogGet(CommonCatalogsNamesEnum.MSP_CATEGORIES);
export const catalogCreateJudgmentCourt = (data: IJudgmentCourt) =>
  action(CatalogsActionsEnum.JUDGMENT_CREATE_COURT, { data });

export const catalogOrdersRelationDictionariesGet = (orderId?: string, orderVersionId?: string) =>
  action(CatalogsActionsEnum.CATALOG_ORDERS_RELATION_DICTIONARIES_GET, {
    orderId,
    orderVersionId,
  });
export const catalogOrdersRelationDictionariesGetRequest = (orderId: string, orderVersionId: string) =>
  action(CatalogsActionsEnum.CATALOG_ORDERS_RELATION_DICTIONARIES_GET_REQUEST, {
    orderId,
    orderVersionId,
  });

export const catalogOrdersRelationDictionariesGetSuccess = (
  orderId: string,
  orderVersionId: string,
  data: IOrderRelation,
) =>
  action(CatalogsActionsEnum.CATALOG_ORDERS_RELATION_DICTIONARIES_GET_SUCCESS, {
    orderId,
    orderVersionId,
    data,
  });
export const catalogOrdersRelationDictionariesGetFailure = (orderId: string, orderVersionId: string) =>
  action(CatalogsActionsEnum.CATALOG_ORDERS_RELATION_DICTIONARIES_GET_FAILURE, {
    orderId,
    orderVersionId,
  });

export const catalogKnmTypes248Get = (params: IKnmTypes248Params) =>
  action(CatalogsActionsEnum.CATALOG_KNM_TYPES_248_GET, { params });

export const catalogKnmTypes248GetRequest = (params: IKnmTypes248Params) =>
  action(CatalogsActionsEnum.CATALOG_KNM_TYPES_248_GET_REQUEST, { params });

export const catalogKnmTypes248GetSuccess = (params: IKnmTypes248Params, data: IKnmType[]) =>
  action(CatalogsActionsEnum.CATALOG_KNM_TYPES_248_GET_SUCCESS, { params, data });

export const catalogKnmTypes248GetFailure = (params: IKnmTypes248Params) =>
  action(CatalogsActionsEnum.CATALOG_KNM_TYPES_248_GET_FAILURE, { params });

export const catalogKnoOrganizationWithChildrenGet = () =>
  action(CatalogsActionsEnum.CATALOG_KNO_ORGANIZATION_WITH_CHILDREN_GET);

export const catalogKnoOrganizationWithChildrenRequest = (uuidKno: string, uuidSupervision: string) =>
  action(CatalogsActionsEnum.CATALOG_KNO_ORGANIZATION_WITH_CHILDREN_GET_REQUEST, {
    uuidKno,
    uuidSupervision,
  });

export const catalogKnoOrganizationWithChildrenSuccess = (
  uuidKno: string,
  uuidSupervision: string,
  data: IUserOrganisation[],
) =>
  action(CatalogsActionsEnum.CATALOG_KNO_ORGANIZATION_WITH_CHILDREN_GET_SUCCESS, {
    uuidKno,
    uuidSupervision,
    data,
  });
export const catalogKnoOrganizationWithChildrenFailure = (uuidKno: string, uuidSupervision: string) =>
  action(CatalogsActionsEnum.CATALOG_KNO_ORGANIZATION_WITH_CHILDREN_GET_FAILURE, {
    uuidKno,
    uuidSupervision,
  });

export const catalogFnsRegistryOkvedCodesGet = (inn: string) =>
  action(CatalogsActionsEnum.CATALOG_FNS_REGISTRY_OKVED_CODES_GET, { inn });
export const catalogFnsRegistryOkvedCodesRequest = (inn: string) =>
  action(CatalogsActionsEnum.CATALOG_FNS_REGISTRY_OKVED_CODES_REQUEST, { inn });
export const catalogFnsRegistryOkvedCodesSuccess = (inn: string, data: string[]) =>
  action(CatalogsActionsEnum.CATALOG_FNS_REGISTRY_OKVED_CODES_SUCCESS, { inn, data });
export const catalogFnsRegistryOkvedCodesFailure = (inn: string) =>
  action(CatalogsActionsEnum.CATALOG_FNS_REGISTRY_OKVED_CODES_FAILURE, { inn });

export const catalogErknmKnoLevelsGet = () => action(CatalogsActionsEnum.CATALOG_ERKNM_KNO_LEVELS_GET);

export const catalogErknmDecisionConditionsGet = (
  knoOrganizationDictVersionId: string,
  supervisionTypeDictVersionId: string,
  decisionKindId: string,
) =>
  action(CatalogsActionsEnum.CATALOG_DECISION_CONDITIONS_GET, {
    knoOrganizationDictVersionId,
    supervisionTypeDictVersionId,
    decisionKindId,
  });
export const catalogErknmDecisionConditionsGetRequest = (
  knoVersionId: string,
  supervisionVersionId: string,
  decisionKindId: string,
) =>
  action(CatalogsActionsEnum.CATALOG_DECISION_CONDITIONS_GET_REQUEST, {
    knoVersionId,
    supervisionVersionId,
    decisionKindId,
  });
export const catalogErknmDecisionConditionsGetSuccess = (
  knoVersionId: string,
  supervisionVersionId: string,
  decisionKindId: string,
  data: IKnmReasonTypeExtended[],
) =>
  action(CatalogsActionsEnum.CATALOG_DECISION_CONDITIONS_GET_SUCCESS, {
    knoVersionId,
    supervisionVersionId,
    decisionKindId,
    data,
  });
export const catalogErknmDecisionConditionsGetFailure = (
  knoVersionId: string,
  supervisionVersionId: string,
  decisionKindId: string,
) =>
  action(CatalogsActionsEnum.CATALOG_DECISION_CONDITIONS_GET_FAILURE, {
    knoVersionId,
    supervisionVersionId,
    decisionKindId,
  });
export const catalogGetErvkObjectsOfControlSelectOptions = (
  query: string,
  callback: (options: ISelectOption[]) => void,
) => action(CatalogsActionsEnum.CATALOG_GET_ERVK_OBJECTS_OF_CONTROL_SELECT_OPTIONS, { query, callback });

export const catalogDecisionGenericReasonsGet = () => action(CatalogsActionsEnum.CATALOG_DECISION_GENERIC_REASONS_GET);

export const catalogDecisionGenericReasonsGetRequest = () =>
  action(CatalogsActionsEnum.CATALOG_DECISION_GENERIC_REASONS_GET_REQUEST);

export const catalogDecisionGenericReasonsGetSuccess = (data: IGenericReason[]) =>
  action(CatalogsActionsEnum.CATALOG_DECISION_GENERIC_REASONS_GET_SUCCESS, { data });

export const catalogDecisionGenericReasonsGetFailure = (params: IKnmTypes248Params) =>
  action(CatalogsActionsEnum.CATALOG_DECISION_GENERIC_REASONS_GET_FAILURE, { params });
